import { BasePlugin } from '../base-plugin.component';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PluginComponent } from '../plugin.component';
import { JobAnalysisPluginService } from './job-analysis-plugin.service';
import { Inspection } from '../../shared/models';

@Component({
    templateUrl: './job-analysis.component.html',
    standalone: false
})
export class JobAnalysisPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;
  public jobAnalysisItems: any;

  constructor(private cdRef: ChangeDetectorRef, private service: JobAnalysisPluginService) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.jobAnalysisItems = this.plugin.config.JobAnalysisItems;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [this.inspectionsRoute, this.inspection.id, 'plugins', this.plugin.id, 'jobanalysis', 'edit'];
  }

  public getAcceptanceRate(job: any) {
    return this.service.getAcceptanceRate(job);
  }
}

PluginComponent.plugins['jobanalysis'] = JobAnalysisPluginComponent;
